import { createReduxActionTypes } from '../../../utils/actionFactory';

const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const UPDATE_USER = 'UPDATE_USER';

export const actionTypes = createReduxActionTypes('ACTIVATION_MESSAGE', [
  OPEN_DIALOG,
  CLOSE_DIALOG,
  UPDATE_USER
]);

const DEFAULT_STATE = {
  open: false,
  users: [],
  fromuserProfile: false,
  isBulkRequest: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_DIALOG]: {
      const { users, fromuserProfile, isBulkRequest } = action;
      return {
        ...state,
        open: true,
        users,
        fromuserProfile,
        isBulkRequest
      };
    }
    case actionTypes[UPDATE_USER]: {
      const { user } = action;
      return {
        ...state,
        users: state.users.map(u =>
          u.username === user.user_id ? { ...u, mitelData: user } : u
        )
      };
    }
    case actionTypes[CLOSE_DIALOG]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openDialog: ({ users, fromuserProfile, isBulkRequest }) => ({
    type: actionTypes[OPEN_DIALOG],
    users,
    fromuserProfile,
    isBulkRequest
  }),
  updateUser: ({ user }) => ({
    type: actionTypes[UPDATE_USER],
    user
  }),
  closeDialog: () => ({ type: actionTypes[CLOSE_DIALOG] })
};
